import { Action } from 'redux';

export const SHOW_ADD_HELP_DOCUMENT_MODAL = 'super-admin-help-document/SHOW_ADD_HELP_DOCUMENT_MODAL';
export const HIDE_ADD_HELP_DOCUMENT_MODAL = 'super-admin-help-document/HIDE_ADD_HELP_DOCUMENT_MODAL';

export const SHOW_ADD_INSTRUCTIONAL_VIDEO_MODAL = 'super-admin-help-document/SHOW_ADD_INSTRUCTIONAL_VIDEO_MODAL';
export const HIDE_ADD_INSTRUCTIONAL_VIDEO_MODAL = 'super-admin-help-document/HIDE_ADD_INSTRUCTIONAL_VIDEO_MODAL';

export const SHOW_ADD_HANDHELD_DOCUMENT_MODAL = 'super-admin-help-document/SHOW_ADD_HANDHELD_DOCUMENT_MODAL';
export const HIDE_ADD_HANDHELD_DOCUMENT_MODAL = 'super-admin-help-document/HIDE_ADD_HANDHELD_DOCUMENT_MODAL';

export const SHOW_DELETE_DOCUMENT_MODAL = 'super-admin-help-document/SHOW_DELETE_DOCUMENT_MODAL';
export const HIDE_DELETE_DOCUMENT_MODAL = 'super-admin-help-document/HIDE_DELETE_DOCUMENT_MODAL';

export const SHOW_VIDEO_PLAYER_MODAL = 'super-admin-help-document/SHOW_VIDEO_PLAYER_MODAL';
export const HIDE_VIDEO_PLAYER_MODAL = 'super-admin-help-document/HIDE_VIDEO_PLAYER_MODAL';

export const SHOW_HELP_DOCUMENT_OPTIONS_MODAL = 'super-admin-help-document/SHOW_HELP_DOCUMENT_OPTIONS_MODAL';
export const HIDE_HELP_DOCUMENT_OPTIONS_MODAL = 'super-admin-help-document/HIDE_HELP_DOCUMENT_OPTIONS_MODAL';

export const GET_HELP_DOCUMENT = 'super-admin-help-documen/GET_HELP_DOCUMENT';
export const SET_HELP_DOCUMENT = 'super-admin-help-documen/SET_HELP_DOCUMENT';

export const ADD_HELP_DOCUMENT = 'super-admin-help-documen/ADD_HELP_DOCUMENT';
export const SET_ADD_HELP_DOCUMENT = 'super-admin-help-documen/SET_ADD_HELP_DOCUMENT';

export const SET_SELECTED_ROW_HELP_DOCUMENT = 'super-admin-help-documen/SET_SELECTED_ROW_HELP_DOCUMENT';
export const DELETE_HELP_DOCUMENT = 'super-admin-help-documen/DELETE_HELP_DOCUMENT';

export const ADD_HANDHELD_DOCUMENT = 'super-admin-help-documen/ADD_HANDHELD_DOCUMENT';

export const showHelpDocumentModal = () => {
  return {
    type: SHOW_ADD_HELP_DOCUMENT_MODAL,
  };
};

export const hideHelpDocumentModal = () => {
  return {
    type: HIDE_ADD_HELP_DOCUMENT_MODAL,
  };
};

export const showInstructionalVideoModal = () => {
  return {
    type: SHOW_ADD_INSTRUCTIONAL_VIDEO_MODAL,
  };
};

export const hideInstructionalVideoModal = () => {
  return {
    type: HIDE_ADD_INSTRUCTIONAL_VIDEO_MODAL,
  };
};

export const showHandheldDocumentModal = () => {
  return {
    type: SHOW_ADD_HANDHELD_DOCUMENT_MODAL,
  };
};

export const hideHandheldDocumentModal = () => {
  return {
    type: HIDE_ADD_HANDHELD_DOCUMENT_MODAL,
  };
};

export const showDeleteDocumentModal = () => {
  return {
    type: SHOW_DELETE_DOCUMENT_MODAL,
  };
};

export const hideDeleteDocumentModal = () => {
  return {
    type: HIDE_DELETE_DOCUMENT_MODAL,
  };
};

export const showVideoPlayerModal = () => {
  return {
    type: SHOW_VIDEO_PLAYER_MODAL,
  };
};

export const hideVideoPlayerModal = () => {
  return {
    type: HIDE_VIDEO_PLAYER_MODAL,
  };
};

export const showHelpDocumentOptionsModal = () => {
  return {
    type: SHOW_HELP_DOCUMENT_OPTIONS_MODAL,
  };
};

export const hideHelpDocumentOptionsModal = () => {
  return {
    type: HIDE_HELP_DOCUMENT_OPTIONS_MODAL,
  };
};

export const getHelpDocument = (data: any) => {
  return {
    type: GET_HELP_DOCUMENT,
    payload: data,
  };
};

export const setHelpDocument = (data: any) => {
  return {
    type: SET_HELP_DOCUMENT,
    payload: data,
  };
};

export const addHelpDocument = (data: any) => {
  return {
    type: ADD_HELP_DOCUMENT,
    payload: data,
  };
};

export const setSelectedRowDocument = (id: any) => {
  return {
    type: SET_SELECTED_ROW_HELP_DOCUMENT,
    payload: id,
  };
};

export const deleteHelpDocument = (data: any) => {
  return {
    type: DELETE_HELP_DOCUMENT,
    payload: data,
  };
};

export const addHandheldDocument = (data: any) => {
  return {
    type: ADD_HANDHELD_DOCUMENT,
    payload: data,
  };
};

export interface setDeleteHelpDocumentAction extends Action<typeof DELETE_HELP_DOCUMENT> {
  readonly payload: any;
}

export interface setSelectedRowDocumentAction extends Action<typeof SET_SELECTED_ROW_HELP_DOCUMENT> {
  readonly payload: any;
}

export interface ShowAddHelpDocumentModal extends Action<typeof SHOW_ADD_HELP_DOCUMENT_MODAL> {
  readonly payload: any;
}

export interface HideAddHelpDocumentModal extends Action<typeof HIDE_ADD_HELP_DOCUMENT_MODAL> {
  readonly payload: any;
}

export interface ShowAddInstructionalVideoModal extends Action<typeof SHOW_ADD_INSTRUCTIONAL_VIDEO_MODAL> {
  readonly payload: any;
}
export interface HideAddInstructionalVideoModal extends Action<typeof HIDE_ADD_INSTRUCTIONAL_VIDEO_MODAL> {
  readonly payload: any;
}

export interface ShowAddHandheldDocumentModal extends Action<typeof SHOW_ADD_HANDHELD_DOCUMENT_MODAL> {}
export interface HideAddHandheldDocumentModal extends Action<typeof HIDE_ADD_HANDHELD_DOCUMENT_MODAL> {}
export interface ShowDeleteDocumentModalAction extends Action<typeof SHOW_DELETE_DOCUMENT_MODAL> {}
export interface HideDeleteDocumentModalAction extends Action<typeof HIDE_DELETE_DOCUMENT_MODAL> {}

export interface ShowVideoPlayerModalAction extends Action<typeof SHOW_VIDEO_PLAYER_MODAL> {}
export interface HideVideoPlayerModalAction extends Action<typeof HIDE_VIDEO_PLAYER_MODAL> {}

export interface ShowHelpDocumentOptionsModalAction extends Action<typeof SHOW_HELP_DOCUMENT_OPTIONS_MODAL> {}
export interface HideHelpDocumentOptionsModalAction extends Action<typeof HIDE_HELP_DOCUMENT_OPTIONS_MODAL> {}

export interface GetHelpDocument extends Action<typeof GET_HELP_DOCUMENT> {
  readonly payload: any;
}
export interface SetHelpDocument extends Action<typeof SET_HELP_DOCUMENT> {
  readonly payload: any;
}

export interface AddHelpDocument extends Action<typeof ADD_HELP_DOCUMENT> {
  readonly payload: any;
}

export interface addHandhelDocumentAction extends Action<typeof ADD_HANDHELD_DOCUMENT> {
  readonly payload: any;
}

export type SuperAdminHelpDocumentAction =
  | setSelectedRowDocumentAction
  | GetHelpDocument
  | SetHelpDocument
  | ShowAddInstructionalVideoModal
  | HideAddInstructionalVideoModal
  | ShowAddHelpDocumentModal
  | HideAddHelpDocumentModal
  | AddHelpDocument
  | ShowAddHandheldDocumentModal
  | HideAddHandheldDocumentModal
  | setDeleteHelpDocumentAction
  | ShowDeleteDocumentModalAction
  | HideDeleteDocumentModalAction
  | ShowVideoPlayerModalAction
  | HideVideoPlayerModalAction
  | addHandhelDocumentAction
  | ShowHelpDocumentOptionsModalAction
  | HideHelpDocumentOptionsModalAction;
